import SubMenu from './component';
import { SubMenuProps } from './types';

export default SubMenu;
export type { SubMenuProps };
